<script setup lang="ts">
import { ParagraphLargeLinklist } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphLargeLinklist
}>()

const items = props.entity.fieldItems?.map((item: any) => {
  return {
    title: item?.entity?.fieldTitle || '',
    subtitle: item?.entity?.fieldSubtitle || '',
    description: item?.entity?.fieldDescription?.processed || '',
    link: {
      url: item?.entity?.fieldLink?.url?.path || '',
      text: item?.entity?.fieldLink?.title || '',
      target: item?.entity?.fieldLink?.attribute || '',
    },
  }
})
</script>

<template>
  <SectionSpecial :title="entity?.fieldTitle || ''">
    <LinkListLarge>
      <template #default="{ isHovered }">
        <LinkListLargeItemEducationalOffering
          v-for="(item, j) of items"
          :key="j"
          v-animate="{ animation: 'vertical-reveal' }"
          :title="item.title"
          :subtitle="item.subtitle"
          :description="item.description"
          :link="item.link"
          :dim="isHovered"
        />
      </template>
    </LinkListLarge>
  </SectionSpecial>
</template>
